import { render, staticRenderFns } from "./ia-cliente-painel.vue?vue&type=template&id=3d71ad20&scoped=true&"
import script from "./ia-cliente-painel.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-painel.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-painel.vue?vue&type=style&index=0&id=3d71ad20&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71ad20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d71ad20')) {
      api.createRecord('3d71ad20', component.options)
    } else {
      api.reload('3d71ad20', component.options)
    }
    module.hot.accept("./ia-cliente-painel.vue?vue&type=template&id=3d71ad20&scoped=true&", function () {
      api.rerender('3d71ad20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-painel.vue"
export default component.exports